import { AppState } from '../index';
import * as fromPayments from './payments.reducer';
import { createSelector } from '@ngrx/store';
import { PaymentsPolicyResponse, PaymentsPolicyResult, PaymentsTransactionResponse } from '../../model/payments.model';
import { PaymentState } from '../../model/payment-state.model';
import AppError from '../../model/app-error';

export const selectPaymentsPolicyState = createSelector(
  (state: AppState) => state.payments,
  ({ policyState }: fromPayments.State) => policyState,
);

export const selectPaymentsPolicyData = createSelector(
  (state: AppState) => state.payments,
  ({ policyData }: fromPayments.State): PaymentsPolicyResponse | null => policyData,
);

export const selectPaymentsPolicyResult = createSelector(
  (state: AppState) => state.payments,
  ({ policyData }: fromPayments.State): PaymentsPolicyResult | null => policyData?.result ?? null,
);

export const selectPaymentsPolicyError = createSelector(
  (state: AppState) => state.payments,
  ({ policyError }: fromPayments.State): AppError | null => policyError,
);

export const selectPaymentsTranscationError = createSelector(
  (state: AppState) => state.payments,
  ({ transactionError }: fromPayments.State): AppError | null => transactionError,
);

export const selectPaymentsTransactionState = createSelector(
  (state: AppState) => state.payments,
  ({ transactionState }: fromPayments.State) => transactionState,
);

export const selectPaymentsTransactionData = createSelector(
  (state: AppState) => state.payments,
  ({ transactionData }: fromPayments.State): PaymentsTransactionResponse | null => transactionData,
);

export const selectPaymentsTransactionStatePrev = createSelector(
  (state: AppState) => state.payments,
  ({ transactionStatePrev }: fromPayments.State) => transactionStatePrev,
);

export const selectPaymentsTransactionErrorPrev = createSelector(
  (state: AppState) => state.payments,
  ({ transactionErrorPrev }: fromPayments.State) => transactionErrorPrev,
);

export const selectPaymentsTransactionDataPrev = createSelector(
  (state: AppState) => state.payments,
  ({ transactionDataPrev }: fromPayments.State): PaymentsTransactionResponse | null => transactionDataPrev,
);

export const selectPaymentsTransactionResult = createSelector(
  (state: AppState) => state.payments,
  ({ transactionData, transactionDataPrev }: fromPayments.State): PaymentState =>
    (transactionData || transactionDataPrev)?.result || PaymentState.declined,
);
